var _path, _circle, _circle2, _circle3, _line;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconCamera(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 42,
    viewBox: "0 0 57 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M55.0135 15.4746V31.9983C55.0135 36.693 51.2076 40.5 46.5135 40.5H10.0107C5.31632 40.5 1.51074 36.6944 1.51074 32V15.4729C1.51074 10.7785 5.31632 6.97291 10.0107 6.97291H12.9328C15.2445 6.97291 17.4305 6.24166 19.332 5.14252C22.6473 3.22616 25.2977 2.44158 27.861 2.50337C30.4441 2.56564 33.1291 3.49093 36.5115 5.35751C38.3164 6.35356 40.3643 6.97291 42.5039 6.97291H46.5135C51.2076 6.97291 55.0135 10.7798 55.0135 15.4746Z",
    stroke: "currentColor",
    strokeWidth: 3
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 28.4907,
    cy: 24.25,
    r: 11,
    stroke: "currentColor",
    strokeWidth: 3
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 28.5107,
    cy: 24.5,
    r: 6,
    stroke: "currentColor",
    strokeWidth: 3
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 42.8157,
    cy: 11.7517,
    r: 1.5,
    stroke: "currentColor",
    strokeWidth: 1.56588
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 8.50781,
    y1: 2.38086,
    x2: 10.499,
    y2: 2.38086,
    stroke: "currentColor",
    strokeWidth: 3,
    strokeLinecap: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCamera);
export default __webpack_public_path__ + "static/media/icon_camera.756f826c19176a330362ab62f85da519.svg";
export { ForwardRef as ReactComponent };